import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import PropertyManagerSidebar from '../../../components/PropertyManager/Sidebar/PropertyManagerSidebar';
import PropertyManagerDashboard from '../../../pages/PropertyManager/Dashboard/PropertyManagerDashboard';
import Portfolio from '../../../pages/PropertyManager/Portfolio/Portfolio';
import BillingPayments from '../../../pages/PropertyManager/BillingPayments/BillingPayments';
import NotFound from '../../../pages/NotFound/v1/NotFound';

const PropertyManagerRoute = () => {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

    useEffect(() => {
        if (!isAuthenticated) {
            window.location.href = '/login';
        }
    }, [isAuthenticated]);

    return (
        <PortalLayout>
            <PropertyManagerSidebar companyName="Management Portal" />
            <MainContent>
                <Routes>
                    <Route path="/" exact element={<PropertyManagerDashboard />} />
                    <Route path="/portfolio" element={<Portfolio />} />
                    <Route path="/billing" element={<BillingPayments />} />
                    <Route path="/*" element={<NotFound />} />
                </Routes>
            </MainContent>
        </PortalLayout>
    );
};

export default PropertyManagerRoute;

const PortalLayout = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    background-color: #f4f6f8;
`;

const MainContent = styled.div`
    flex: 1;
    overflow-y: auto;
    height: 100%;
`;
